import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=746e1d9c&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e1d9c",
  null
  
)

export default component.exports